/* globals $shell */
import * as dompack from 'dompack';
import { Class } from "@webhare-system/frameworks/mootools/core";
import { qS } from 'dompack/extra/qsa';
import * as whintegration from '@webhare-system/wh/integration';
const $todd = require("../support");
const getTid = require("@webhare-tollium/gettid").getTid;
const domtemplate = require('@webhare-system/dom/template');
const utilerror = require('@webhare-system/wh/errorreporting');
const focuszones = require('../../components/focuszones');
const toddImages = require("../images");
require("../../common.lang.json");

function createAppMenu(items)
{
  items=items.map(item=>
  {
    let header = [ dompack.create('span', { textContent: item.title })
                 ];
    if(item.editinstr)
    {
      let cogimage = toddImages.createImage('tollium:objects/cog2',16,16,'w', { className: "dashboard__editgroupicon"
                                                                              , title: item.edittitle
                                                                              });
      let editnode = dompack.create('span', { className: "dashboard__editgroup"
                                            , childNodes: [ cogimage ]
                                            });
      editnode.store("instr",item.editinstr);
      header.push(editnode);
    }

    let appnodes = item.apps.map(app =>
    {
      let node = dompack.create('li', { childNodes:
           [ dompack.create('div', { childNodes:
             [ app.icon ? toddImages.createImage(app.icon, 16, 16, 'w', { className: "dashboard__appicon" }) : null
             , dompack.create('span', {className: "dashboard__apptitle", textContent: app.title })
             ]})
           ]});
      node.store("instr", app.instr);
      return node;
    });

    return dompack.create('li', { childNodes: [ dompack.create('div', {childNodes:header})
                                              , dompack.create('ul', {childNodes: appnodes })
                                              ]});
  });
  return dompack.create('nav',{className:"dashboard__apps"
                               ,"childNodes":items
                               });
}

var DashboardApp = new Class(
{ initialize:function(appinterface, callback)
  {
    this.app = appinterface;
    this.app.onappstackbottom = true; //we don't want to be in the app activation stack

    this.dashboardappsnode = dompack.create('nav', {className:"dashboard__apps"});

    this.node = dompack.create('div', { "id": "dashboard"
                                       , className: "dashboard wh-focuszone"
                                       , "childNodes":
        [ this.dashboardappsnode
        , dompack.create('div', { className:"dashboard__footer"
                                 , "childNodes": this.createDashboardFooter()
                                 })
        , dompack.create('div', {"id":"dashboard-bg"})
        , dompack.create('div', {"id":"dashboard-newsarea"})
        ]});
    this.app.getAppCanvas().adopt(this.node); //move dashboard into our new app

    this.shell = $shell;
    this.shell.addEvent("settingschange", this.updateShellSettings.bind(this));
    this.shell.addEvent("webhareconnectchange", this.updateShellHaveConnect.bind(this));

  //  $('dashboard-dashboard').addEvent("click", this.shell.onDashboardClick.bind(this.shell));
    this.node.addEvents( { "click:relay(li li, li .dashboard__editgroup)": this.onMenuClick.bind(this)
                          , "contextmenu:relay(li li)": this.onMenuContext.bind(this)
                          , "mousedown": function(event) { event.preventDefault(); } //prevent focus loss on MSIE. other browsers don't seem to need this? ADDME fix for IE too?
                          //, "wh-focuszone-focus": this.onFocus.bind(this)
                         // , "wh-focuszone-blur": this.onBlur.bind(this)
                          });

    this.app.updateApplicationProperties({ title: getTid("tollium:shell.dashboard.apptitle")
                                         , appicon: 'tollium:objects/webhare'
                                         , appiconwidth:28
                                         , appiconheight:28
                                         , tabmodifier: 'dashboard'
                                         });
    this.updateShellSettings();
    this.updateShellHaveConnect();
    callback();
  }
, openDashboard:function()
  {
    focuszones.focusZone(this.node);
  }
, createDashboardFooter:function()
  {
    return [ dompack.create('div', { "id": "dashboard-user"
                                   , "on": { "click": () => this.shell.editPersonalSettings() }
                                   })
           , dompack.create('div', { "id": "dashboard-logout"
                                    , "on": { "click": () => this.runLogout() }
                                    , childNodes:
               [ dompack.create('span', { textContent: getTid("tollium:shell.dashboard.logout")
                                          })
               , toddImages.createImage('tollium:actions/logout',16,16,'w', { className: "dashboard__logoutimg"})
               ]
             })
           ];
  }
, updateShellSettings:function(event)
  {
    var settings = this.shell.getCurrentSettings();
    let newmenu = createAppMenu(settings.apps);
    dompack.replaceWith(this.dashboardappsnode, newmenu);
    this.dashboardappsnode = newmenu;

    dompack.empty(qS('#dashboard-user'));
    let usericon = this.shell.getCurrentSettings().issysop ? 'tollium:users/manager' : 'tollium:users/user';
    dompack.append(qS('#dashboard-user')
                  ,toddImages.createImage(usericon,16,16,'w', { className: "dashboard__userimg" })
                  ,dompack.create('span', { "id": "dashboard-user-name", "textContent": settings.userdisplayname }));

    document.getElementById('dashboard-bg').setStyle('background-image', 'url(' + settings.dashboardbg + ')');
    document.getElementById('dashboard-bg').setStyle('background-position', settings.dashboardbgpos);

    document.getElementById('dashboard-display-name').set('text', settings.displayname);
    if(settings.displayimage == "")
    {
      document.getElementById('t-apptabs').setStyle("background-image", "none");
      document.getElementById('dashboard-display-name').set('text', settings.displayname);
    }
    else
    {
      document.getElementById('dashboard-display-name').set('text', "");
      document.getElementById('t-apptabs').setStyle("background-image", "url(" + settings.displayimage + ")");
    }
    document.getElementById('dashboard-logout').toggleClass("dashboard-logout--allowed", settings.allowlogout);
    document.getElementById('dashboard-newsarea').empty();
    for(var i = 0; i < settings.newsitems.length; i++)
    {
      domtemplate.expandTemplate(document.getElementById('dashboard-newsitem'), settings.newsitems[i], { injectinto: document.getElementById('dashboard-newsarea') } );
    }
  }
, updateShellHaveConnect:function()
  {
    if(this.shell.hasWebHareConnect())
    {
      this.app.appmenu = [{ title: getTid("tollium:shell.dashboard.mountwebhare"), cmd: { type: "shell:reveal", folder: "/" } }
                         ];
    }
    else
    {
      this.app.appmenu = [];
    }

    if(whintegration.config.dtapstage == 'development')
      this.app.appmenu.push({ title: getTid("tollium:shell.dashboard.resetimagecache"), cmd: { type: "shell:resetimagecache" } });
  }
, onMenuClick:function(event,menuitem)
  {
    var instr = menuitem.retrieve("instr");
    if(instr)
    {
      this.shell.executeInstruction(instr);
      return;
    }
  }
, onMenuContext:function(event, menuitem)
  {
  }
, runLogout:function()
  {
    var block = this.app.getBusyLock();
    $todd.createMessageBox(this.app, { title: getTid("tollium:shell.logout.title")
                                     , text: getTid("tollium:shell.logout.surelogout")
                                     , buttons: [{ name: 'yes', title: getTid("tollium:common.actions.yes") }
                                                ,{ name: 'no', title: getTid("tollium:common.actions.no") }
                                                ]
                                     , onclose:function(result)
                                       {
                                         if(result=='yes')
                                           this.shell.doLogoff();
                                       }.bind(this)
                                     })
    .then( () => console.log( document.body.getElements('t-button') ))
    .finally( () => { console.log("will release"); block.release(); })
    .catch(utilerror.reportException);
  }
});


$todd.registerJSApp('tollium:builtin.dashboard', DashboardApp);



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/apps/dashboard.es